import { getItemFromPagination } from 'store/Items/selector'
import { getModifierGroups } from 'store/ModifierGroups/selectors'
import { mapModifierGroupsToItemMappings } from 'utils/items'

export const getItemMappings = (state) =>
  Object.values(state?.itemMappings?.byId) ?? []

export const getIsItemMappingsLoading = (state) =>
  state?.itemMappings?.isLoading ?? false

export const getModifierMinMax = (state, itemId) => {
  // get modifier groups uuids assigned to item
  const { modifierItemCategoryUuids, id } = getItemFromPagination(
    state,
    itemId
  )
  const itemMappings = getItemMappings(state)
  const allModifierGroups = getModifierGroups(state)

  // find modifier groups objects assigned to item
  const modifierGroups = allModifierGroups?.filter((modifierGroup) =>
    modifierItemCategoryUuids?.includes(modifierGroup?.uuid)
  )

  // map modifier groups to item mappings
  const mappedModifierGroups = mapModifierGroupsToItemMappings(
    modifierGroups,
    itemMappings,
    id
  )

  const modifierMinMax = mappedModifierGroups.map(
    (mappedModifierGroup) => ({
      modifierUuid: modifierGroups.find(
        (modifierGroup) =>
          modifierGroup.id === mappedModifierGroup.mappedObjectId
      )?.uuid,
      minimumCount: mappedModifierGroup?.minimumCount ?? null,
      maximumCount: mappedModifierGroup?.maximumCount ?? null,
    })
  )

  return modifierMinMax
}
